import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ModalsState } from 'types/state';

const modalSlice = createSlice({
  name: 'MODAL',
  initialState: [] as ModalsState,
  reducers: {
    openModal: (state, action: PayloadAction<{ modalType: string; modalProps: Record<string, unknown> }>) => {
      const { modalType, modalProps } = action.payload;
      return state.concat({ modalType, modalProps });
    },
    closeModal: (state) => {
      // Always popping the last modal off the stack
      const newState = state.slice();
      newState.pop();
      return newState;
    },
    closeAllModals: () => {
      return [];
    },
  },
});

export const { openModal, closeModal, closeAllModals } = modalSlice.actions;
export default modalSlice.reducer;
